import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import '../../App.css';
import '../../popup.css';
import { useOrdProd } from './OrdProdContext';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        fontFamily: 'WorkSans',
        position: 'absolute',
        width: 588,

        backgroundColor: theme.palette.background.paper,
        //border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: '0px 0px 0px 0px',
    },
}));

const useStyles1 = makeStyles((theme) => ({
    paper: {
        fontFamily: 'WorkSans',
        position: 'absolute',
        width: 1050,
        backgroundColor: theme.palette.background.paper,
        //border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: '0px 0px 0px 0px',
    },
}));

function PopUp(props) {
    const { importOrd, setImportOrd, nuevo, productos, setNuevo, setProductos, editar, setEditar } =
        useOrdProd();
    const [open, setOpen] = useState(false);
    const classes = useStyles();
    const classes1 = useStyles1();
    const [modalStyle] = React.useState(getModalStyle);
    const selcClass = props.popupFlag ? classes1.paper : classes.paper;

    useEffect(() => {
        switch (props.name) {
            case 'import':
                setOpen(importOrd);
                break;
            case 'nuevo':
                setOpen(nuevo);
                break;
            case 'productos':
                setOpen(productos);
                break;
            case 'editar':
                setOpen(editar);
                break;
            default:
                break;
        }
    }, [importOrd, nuevo, productos, editar, props.name]);

    const handleOpen = () => {
        switch (props.name) {
            case 'import':
                setImportOrd(true);
                setProductos(false);
                setNuevo(false);
                setEditar(false);
                break;
            case 'nuevo':
                setNuevo(true);
                setImportOrd(false);
                setProductos(false);
                setEditar(false);
                break;
            case 'productos':
                setProductos(true);
                setNuevo(true);
                setImportOrd(false);
                setEditar(false);
                break;
            case 'editar':
                setEditar(true);
                setImportOrd(false);
                setProductos(false);
                setNuevo(false);
                break;
            default:
                break;
        }
    };

    const handleClose = () => {
        switch (props.name) {
            case 'import':
                setImportOrd(false);
                break;
            case 'nuevo':
                setNuevo(false);
                break;
            case 'productos':
                setProductos(false);
                break;
            case 'editar':
                setEditar(false);
                break;
            default:
                break;
        }
    };

    const body = (
        <div style={modalStyle} className={selcClass}>
            {props.title && (
                <div className="popuphead">
                    <h2 className="popuptitle">{props.title}</h2>
                    {props.titleDesc && <p className="popuptitled">{props.titleDesc}</p>}
                </div>
            )}
            <div id="simple-modal-description">
                {props.popupBody}
                <div className="popupbottom">
                    <Button
                        variant="outlined"
                        color="primary"
                        className="popup-button-s"
                        onClick={handleClose}
                    >
                        {props.popupSeconButton}
                    </Button>
                    {props.popupPrimAction}
                </div>
            </div>
        </div>
    );

    return (
        <div>
            <Button
                variant={props.isContained}
                color={props.colorButton}
                className={props.buttonClass}
                onClick={handleOpen}
                disabled={!props.isActive}
            >
                {props.textButton}
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
}

PopUp.defaultProps = {
    textButton: 'Agregar',
    colorButton: 'primary',
    title: null,
    titleDesc: null,
    popupPrimButton: 'Aceptar',
    popupSeconButton: 'Cancelar',
    isContained: 'contained',
    isActive: true,
    popupPrimAction: null,
};

export default PopUp;
